import faker from 'faker'
import moment from 'moment'
import hrmsLovLabels from 'assets/labels/hrmsLov'

export const mocker = {
  lovLabels () {
    return {
      labels: hrmsLovLabels
    }
  },
  lovCodempid () {
    let mockRows = []
    let staemp = ''
    const mockStaemp = [ 'P', 'Y' ]
    const mockStatus = {
      'P': 'ทดลองงาน',
      'Y': 'ปัจจุบัน'
    }
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      staemp = mockStaemp[Math.floor(Math.random() * 2)]
      mockRows.push({
        codempid: faker.lorem.word(),
        namempe: faker.name.findName(),
        namempt: faker.name.findName(),
        namemp3: faker.name.findName(),
        namemp4: faker.name.findName(),
        namemp5: faker.name.findName(),
        desstaemp: mockStatus[staemp],
        staemp: ''
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodempstapp () {
    let mockRows = []
    let staemp = ''
    const mockStaemp = [ 'P' ]
    const mockStatus = {
      'P': 'ทดลองงาน'
    }
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      staemp = mockStaemp
      mockRows.push({
        codempstapp: faker.lorem.word(),
        namempe: faker.name.findName(),
        namempt: faker.name.findName(),
        namemp3: faker.name.findName(),
        namemp4: faker.name.findName(),
        namemp5: faker.name.findName(),
        desc_staemp: mockStatus[staemp],
        staemp: ''
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodpos () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codpos: faker.lorem.word(),
        nampose: faker.name.findName(),
        nampost: faker.name.findName(),
        nampos3: faker.name.findName(),
        nampos4: faker.name.findName(),
        nampos5: faker.name.findName()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodapp () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codapp: faker.lorem.word(),
        namappe: faker.name.findName(),
        namappt: faker.name.findName(),
        namapp3: faker.name.findName(),
        namapp4: faker.name.findName(),
        namapp5: faker.name.findName()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovNummemo () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        nummemo: faker.random.word(),
        dteyear: moment().format('YYYY'),
        dtemonth: moment().format('MMMM'),
        numclseq: faker.random.number().toString().substr(0, 1),
        namcourse: faker.random.words(),
        namcourst: faker.random.words(),
        namcours3: faker.random.words(),
        namcours4: faker.random.words(),
        namcours5: faker.random.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodcours () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codcours: faker.random.word(),
        namcourse: faker.random.words(),
        namcourst: faker.random.words(),
        namcours3: faker.random.words(),
        namcours4: faker.random.words(),
        namcours5: faker.random.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodform () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codform: faker.random.word(),
        desforme: faker.random.words(),
        desformt: faker.random.words(),
        desform3: faker.random.words(),
        desform4: faker.random.words(),
        desform5: faker.random.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovNumappl () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        numappl: faker.random.word(),
        desapple: faker.random.words(),
        desapplt: faker.random.words(),
        desappl3: faker.random.words(),
        desappl4: faker.random.words(),
        desappl5: faker.random.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovNumreq () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        numreq: faker.random.number(),
        codcomp: faker.random.words(),
        codpos: faker.lorem.word(),
        nampose: faker.name.findName(),
        nampost: faker.name.findName(),
        nampos3: faker.name.findName(),
        nampos4: faker.name.findName(),
        nampos5: faker.name.findName()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodaplvl () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codaplvl: faker.random.word(),
        descode: faker.random.words(),
        descodt: faker.random.words(),
        descod3: faker.random.words(),
        descod4: faker.random.words(),
        descod5: faker.random.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovGrdscor () {
    let mockRows = []
    let grdscor = ''
    const mockGrdscor = [ '5', '10', '15', '20' ]
    const mockQtyscor = {
      '5': '5.00',
      '10': '10.00',
      '15': '15.00',
      '20': '20.00'
    }
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      grdscor = mockGrdscor[Math.floor(Math.random() * 2)]
      mockRows.push({
        grdscor: '55',
        grditem: mockGrdscor[grdscor],
        achieve: 'TEST',
        qtyscor: mockQtyscor[grdscor]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodappr () {
    let mockRows = []
    let staemp = ''
    const mockStaemp = [ 'P', 'Y' ]
    const mockStatus = {
      'P': 'ทดลองงาน',
      'Y': 'ปัจจุบัน'
    }
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      staemp = mockStaemp[Math.floor(Math.random() * 2)]
      mockRows.push({
        codappr: faker.lorem.word(),
        namempe: faker.name.findName(),
        namempt: faker.name.findName(),
        namemp3: faker.name.findName(),
        namemp4: faker.name.findName(),
        namemp5: faker.name.findName(),
        desstaemp: mockStatus[staemp],
        staemp: ''
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodshift () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codshift: faker.lorem.word(),
        desshifte: faker.name.findName(),
        desshiftt: faker.name.findName(),
        desshift3: faker.name.findName(),
        desshift4: faker.name.findName(),
        desshift5: faker.name.findName(),
        schedule: faker.date.past().toString().substr(15, 6) + ' - ' + faker.date.future().toString().substr(15, 6)
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodroom () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codroom: faker.lorem.word(),
        roomname: faker.name.findName(),
        roomnamt: faker.name.findName(),
        roomnam3: faker.name.findName(),
        roomnam4: faker.name.findName(),
        roomnam5: faker.name.findName()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodasset () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codasset: faker.lorem.word(),
        desassee: faker.name.findName(),
        desasset: faker.name.findName(),
        desasse3: faker.name.findName(),
        desasse4: faker.name.findName(),
        desasse5: faker.name.findName()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodcalen () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codcalen: faker.lorem.word(),
        descalene: faker.lorem.words(),
        descalent: faker.lorem.words(),
        descalen3: faker.lorem.words(),
        descalen4: faker.lorem.words(),
        descalen5: faker.lorem.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodcompy () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codcompy: faker.lorem.word(),
        descompye: faker.lorem.words(),
        descompyt: faker.lorem.words(),
        descompy3: faker.lorem.words(),
        descompy4: faker.lorem.words(),
        descompy5: faker.lorem.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovBatchno () {
    let mockRows = []
    let mockBatchno = [
      '5651',
      '5652',
      '5653',
      '5654',
      '5655',
      '5656',
      '5657',
      '5658'
    ]
    let mockEntrydte = [
      '01/01/2017',
      '02/01/2017',
      '03/01/2017',
      '04/01/2017',
      '05/01/2017',
      '01/03/2017',
      '03/04/2017',
      '10/04/2017'
    ]
    let mockLastseq = [
      '78',
      '50',
      '100',
      '23',
      '60',
      '14',
      '69',
      '25'
    ]
    const mockTotal = 8
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        batchno: mockBatchno[i - 1],
        entrydte: mockEntrydte[i - 1],
        lastseq: mockLastseq[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCostcent () {
    let mockRows = []
    let mockCostcent = [ '10000', '10001', '10002' ]
    let mockDesc = [ 'BU-01', 'BU-02', 'BU-03' ]
    const mockTotal = 3
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        costcent: mockCostcent[i - 1],
        descostcente: mockDesc[i - 1],
        descostcentt: mockDesc[i - 1],
        descostcent3: mockDesc[i - 1],
        descostcent4: mockDesc[i - 1],
        descostcent5: mockDesc[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodbrlc () {
    let mockRows = []
    let mockCodbrlc = [ '000000', '000000', '000001', '000001' ]
    let mockDescCodbrlc = [ 'PPS', 'PPS', 'TJS', 'TJS' ]
    const mockTotal = 4
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codbrlc: mockCodbrlc[i - 1],
        descodbrlce: mockDescCodbrlc[i - 1],
        descodbrlct: mockDescCodbrlc[i - 1],
        descodbrlc3: mockDescCodbrlc[i - 1],
        descodbrlc4: mockDescCodbrlc[i - 1],
        descodbrlc5: mockDescCodbrlc[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodtency () {
    let mockRows = []
    const mockCodtency = [
      'C001',
      'F001',
      'M001'
    ]
    const mockDescCodtency = [
      'Core Competency',
      'Functional Competency',
      'Management Competency'
    ]
    const mockTotal = 3
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codtency: mockCodtency[i - 1],
        descodtencye: mockDescCodtency[i - 1],
        descodtencyt: mockDescCodtency[i - 1],
        descodtency3: mockDescCodtency[i - 1],
        descodtency4: mockDescCodtency[i - 1],
        descodtency5: mockDescCodtency[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodedlv () {
    let mockRows = []
    const mockcodedlv = [
      '0000',
      '0001',
      '0002',
      '0003',
      '0004',
      '0005',
      '0006',
      '0007',
      '0008',
      '0009',
      '0010'
    ]
    const mockdesccodedlv = [
      'N/A',
      'ปริญญาเอก',
      'ปริญญาโท',
      'ปริญญาตรี',
      'อนุปริญญา',
      'ประกาศนียบัตรวิชาชีพ (ปวท.)',
      'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.)',
      'ประกาศนียบัตรวิชาชีพ (ปวช.)',
      'มัธยมศึกษาตอนปลาย',
      'มัธยมศึกษาตอนต้น',
      'ประถมศึกษา'
    ]
    const mockTotal = 11
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codedlv: mockcodedlv[i - 1],
        descodedlve: mockdesccodedlv[i - 1],
        descodedlvt: mockdesccodedlv[i - 1],
        descodedlv3: mockdesccodedlv[i - 1],
        descodedlv4: mockdesccodedlv[i - 1],
        descodedlv5: mockdesccodedlv[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodjob () {
    let mockRows = []
    const mockcodjob = [
      '0001',
      '0002',
      '0003',
      '0004',
      '0005',
      '01',
      '02',
      'DI',
      'ENGI',
      'IN',
      'JS',
      'OFFI',
      'TS'
    ]
    const mockdesccodjob = [
      'รายเดือน (พ.ประจำ)',
      'ผู้บริหาร/ผู้จัดการญี่ปุ่น',
      'พนักงานสัญญาจ้าง',
      'นักศึกษาฝึกงาน',
      'ที่ปรึกษา',
      'รายเดือน',
      'รายวัน',
      'Direct',
      'Engineer',
      'Indirect',
      'Japanese Staff',
      'Office',
      'Thai Staff'
    ]
    const mockTotal = 13
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codjob: mockcodjob[i - 1],
        descodjobe: mockdesccodjob[i - 1],
        descodjobt: mockdesccodjob[i - 1],
        descodjob3: mockdesccodjob[i - 1],
        descodjob4: mockdesccodjob[i - 1],
        descodjob5: mockdesccodjob[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodempmt () {
    let mockRows = []
    const mockcodempmt = [
      '0001',
      '0002',
      '0003',
      '0004',
      '01',
      '02',
      '03',
      '1000',
      'D',
      'M',
      'PE',
      'SC',
      'TE'
    ]
    const mockdesccodempmt = [
      'รายเดือน',
      'รายวัน',
      'นักศึกษาฝึกงาน',
      'สัญญาจ้าง',
      'รายเดือน',
      'รายวัน',
      'Part Time',
      'รายเดือน สนญ.',
      'รายวัน',
      'รายเดือน',
      'Permanent',
      'Sub Contract',
      'Tempolary'
    ]
    const mockTotal = 13
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codempmt: mockcodempmt[i - 1],
        descodempmte: mockdesccodempmt[i - 1],
        descodempmtt: mockdesccodempmt[i - 1],
        descodempmt3: mockdesccodempmt[i - 1],
        descodempmt4: mockdesccodempmt[i - 1],
        descodempmt5: mockdesccodempmt[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovTypemp () {
    let mockRows = []
    const mocktypemp = [
      '0001',
      '0002',
      '0003',
      '0004',
      '0005',
      '01',
      '02',
      'DI',
      'ENGI',
      'IN',
      'JS',
      'OFFI',
      'TS'
    ]
    const mockdesctypemp = [
      'รายเดือน (พ.ประจำ)',
      'ผู้บริหาร/ผู้จัดการญี่ปุ่น',
      'พนักงานสัญญาจ้าง',
      'นักศึกษาฝึกงาน',
      'ที่ปรึกษา',
      'รายเดือน',
      'รายวัน',
      'Direct',
      'Engineer',
      'Indirect',
      'Japanese Staff',
      'Office',
      'Thai Staff'
    ]
    const mockTotal = 13
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        typemp: mocktypemp[i - 1],
        destypempe: mockdesctypemp[i - 1],
        destypempt: mockdesctypemp[i - 1],
        destypemp3: mockdesctypemp[i - 1],
        destypemp4: mockdesctypemp[i - 1],
        destypemp5: mockdesctypemp[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovTyppayroll () {
    let mockRows = []
    const mocktyppayroll = [
      '0001',
      '0002',
      '0003',
      '01',
      '02',
      '03',
      '04',
      'M1',
      'M2',
      'XXX1'
    ]
    const mockdesctyppayroll = [
      'รายเดือน',
      'รายวัน',
      'นักศึกษา',
      'รายเดือนผู้บริหารสำนักงานใหญ่',
      'รายเดือนสำนักงานใหญ่',
      'รายเดือนสาขา',
      'รายวันสาขา',
      'รายได้ประจำเดือนละ 1 งวด',
      'รายได้ประจำเดือนละ 2 งวด',
      'XXXX-รายเดือน-XXXX'
    ]
    const mockTotal = 10
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        typpayroll: mocktyppayroll[i - 1],
        destyppayrolle: mockdesctyppayroll[i - 1],
        destyppayrollt: mockdesctyppayroll[i - 1],
        destyppayroll3: mockdesctyppayroll[i - 1],
        destyppayroll4: mockdesctyppayroll[i - 1],
        destyppayroll5: mockdesctyppayroll[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCodinst () {
    let mockRows = []
    const mockcodinst = [
      '0000',
      '0001',
      '0002',
      '0003',
      '0004',
      '0005',
      '0006',
      '0007',
      '0008',
      '0009',
      '0010',
      '0011',
      '0012',
      '0013',
      '0014'
    ]
    const mockdesccodinst = [
      'N/A',
      'จุฬาลงกรณ์มหาวิทยาลัย',
      'มหาวิทยาลัยเกษตรศาสตร์',
      'มหาวิทยาลัยขอนแก่น',
      'มหาวิทยาลัยเชียงใหม่',
      'มหาวิทยาลัยทักษิณ',
      'มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี',
      'มหาวิทยาลัยเทคโนโลยีสุรนารี',
      'มหาวิทยาลัยธรรมศาสตร์',
      'มหาวิทยาลัยนเรศวร',
      'มหาวิทยาลัยบูรพา',
      'มหาวิทยาลัยมหาสารคาม',
      'มหาวิทยาลัยมหิดล',
      'มหาวิทยาลัยแม่โจ้',
      'มหาวิทยาลัยแม่ฟ้าหลวง'
    ]
    const mockTotal = 15
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codinst: mockcodinst[i - 1],
        descodinste: mockdesccodinst[i - 1],
        descodinstt: mockdesccodinst[i - 1],
        descodinst3: mockdesccodinst[i - 1],
        descodinst4: mockdesccodinst[i - 1],
        descodinst5: mockdesccodinst[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovStaemp () {
    let mockRows = []
    const mockstaemp = [
      '',
      '',
      '',
      ''
    ]
    const mockdescstaemp = [
      '',
      '',
      '',
      ''
    ]
    const mockTotal = 4
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        staemp: mockstaemp[i - 1],
        desstaempe: mockdescstaemp[i - 1],
        desstaempt: mockdescstaemp[i - 1],
        desstaemp3: mockdescstaemp[i - 1],
        desstaemp4: mockdescstaemp[i - 1],
        desstaemp5: mockdescstaemp[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCoddomcl () {
    let mockRows = []
    const mockcoddomcl = [
      '',
      '',
      '',
      ''
    ]
    const mockdesccoddomcl = [
      '',
      '',
      '',
      ''
    ]
    const mockTotal = 4
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        coddomcl: mockcoddomcl[i - 1],
        descoddomcle: mockdesccoddomcl[i - 1],
        descoddomclt: mockdesccoddomcl[i - 1],
        descoddomcl3: mockdesccoddomcl[i - 1],
        descoddomcl4: mockdesccoddomcl[i - 1],
        descoddomcl5: mockdesccoddomcl[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovTypleave () {
    let mockRows = []
    const mockcode = [
      '',
      '',
      '',
      ''
    ]
    const mockdesccode = [
      '',
      '',
      '',
      ''
    ]
    const mockTotal = 4
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        typleave: mockcode[i - 1],
        destypleavee: mockdesccode[i - 1],
        destypleavet: mockdesccode[i - 1],
        destypleave3: mockdesccode[i - 1],
        destypleave4: mockdesccode[i - 1],
        destypleave5: mockdesccode[i - 1]
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  lovCoursTrain () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        courstrain: faker.random.word(),
        descourstraine: faker.random.words(),
        descourstraint: faker.random.words(),
        descourstrain3: faker.random.words(),
        descourstrain4: faker.random.words(),
        descourstrain5: faker.random.words()
      })
    }
    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrmsLov/mocker.js